"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Relay42Constants = {
    DEFAULT_PERMISSION_LEVEL: 1
};

exports.default = Relay42Constants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/relay42/relay42.constants.js
// module id = 813
// module chunks = 0